import styled from "@emotion/styled";
import { Fragment } from "react";
import type { ReactNode } from "react";

import { MDSText, MDSTextColor, MDSTextVariant } from "@/mds";

export type AgentMetaItem = {
  label: string;
  value: ReactNode;
};

export const AgentMetaCard = ({ items }: { items: AgentMetaItem[] }) => (
  <StyledCard>
    <StyledGrid>
      {items.map(item => (
        <Fragment key={item.label}>
          <StyledLabel>
            <MDSText color={MDSTextColor.Secondary} variant={MDSTextVariant.TextS}>
              {item.label}
            </MDSText>
          </StyledLabel>
          <StyledValue>
            {typeof item.value === "string" ? (
              <MDSText color={MDSTextColor.Primary} variant={MDSTextVariant.TextS}>
                {item.value}
              </MDSText>
            ) : (
              item.value
            )}
          </StyledValue>
        </Fragment>
      ))}
    </StyledGrid>
  </StyledCard>
);

export const AgentMetaMonospace = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: ${({ theme }) => theme.fontSizes[MDSTextVariant.TextXs]};
  word-break: break-all;
`;

const StyledCard = styled.aside`
  background: ${({ theme }) => theme.colors.background.input.chrome.default};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: ${({ theme }) => theme.spacing[5]};
`;

const StyledGrid = styled.dl`
  display: grid;
  gap: ${({ theme }) => theme.spacing[3]} ${({ theme }) => theme.spacing[5]};
  grid-template-columns: minmax(120px, auto) 1fr;
  margin: 0;
`;

const StyledLabel = styled.dt`
  margin: 0;
  min-width: 0;
`;

const StyledValue = styled.dd`
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
`;
